<template>
  <div class="list" name="count">
    <el-col style="margin-top:-18px">
      <el-form :inline="true" class="demo-inline-form" :model="search_sale">
        <el-card class="searchCard" shadow="never">
          <el-form-item label="录入日期">
            <el-date-picker
              v-model="creatTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="机具编号">
            <el-input
              placeholder="机具编号"
              style="width:160px;"
              v-model="search_sale.fSn"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="维修费用">
            <el-select
              style="width:100px;"
              v-model="search_sale.fRepairCost"
              clearable>
              <el-option label="有" value="1"></el-option>
              <el-option label="无" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              style="width:150px;"
              v-model="search_sale.fState"
              clearable>
              <el-option label="全部" value="-1"></el-option>
              <el-option label="未收货" value="0"></el-option>
              <el-option label="已录入" value="1"></el-option>
              <el-option label="收货信息有误" value="2"></el-option>
              <el-option label="维修中" value="3"></el-option>
              <el-option label="待付维修款" value="4"></el-option>
              <el-option label="已完成" value="9"></el-option>
              <el-option label="申请寄回" value="16"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttomSearch"
              :loading="checkLoading"
              label="查询"></auth-button>
          </el-form-item>

          <el-col style="width: 100%;height: 35px;">
            <div class="rule-button" style="float:left;color: #1e90ff;cursor: pointer;" @click="showMsg(1)">《报修机具总部收货地址》</div>
            <div class="rule-button" style="float:left;color: #1e90ff;cursor: pointer;" @click="showMsg(2)">《收费维修价目表》</div>
          </el-col>
        </el-card>
        <el-card class="tableCard" shadow="never">
          <!-- 列表模块 -->
          <el-table
            stripe
            border
            style="width:100%"
            align="center"
            v-loading="saleLoading"
            :data="sale_list"
            :header-cell-style="{background:'#FAFAFA'}"
            @sort-change="tableSortChange">

            <el-table-column
              prop="fCreateTime"
              label="录入时间"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="fState"
              label="状态"
              align="center"
              :formatter="fStateFormatter">
            </el-table-column>
            <el-table-column
              prop="fSn"
              label="机具编号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fAgentId"
              label="代理商编号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fReworkAgent"
              label="返修原因"
              align="center">
            </el-table-column>
            <el-table-column
              prop="components"
              label="配件"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fQeTrouble"
              label="故障原因"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fRepairCost"
              label="维修费用"
              align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.fRepairCost / 100 || scope.row.fRepairCost }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="fAgentExpressNo"
              label="寄出快递单号"
              align="center">
            </el-table-column>
            <el-table-column
              label="操作"
              width="300"
              align="left"
              fixed="right"
              :context="_self">
              <template slot-scope="scope">
                <auth-button
                  opt="details"
                  icon="el-icon-edit"
                  size="mini"
                  label="详情"
                  @click.native="handleCheck(scope.$index,scope.row)"></auth-button>
                <auth-button
                  opt="edit"
                  type="changeState"
                  icon="el-icon-bell"
                  size="mini"
                  v-if="scope.row.fState === 0 || scope.row.fState === 2"
                  label="编辑"
                  @click.native="handleEditSn(scope.$index,scope.row)"></auth-button>
                <auth-button
                  opt="apply"
                  type="changeState"
                  icon="el-icon-bell"
                  size="mini"
                  label="申请寄回"
                  v-if="scope.row.fState === 11 || scope.row.fState === 12 || scope.row.fState === 13"
                  @click.native="applyBack(scope.$index,scope.row)"></auth-button>
                <!-- v-if="scope.row.fState === 11 || scope.row.fState === 12 || scope.row.fState === 13" -->
              </template>
            </el-table-column>

          </el-table>
        </el-card>
      </el-form>
    </el-col>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage"
      ></el-pagination>
    </el-col>

    <!-- 详情界面 -->
    <el-dialog title="" :visible.sync="dialogVisible" size="small" @close="closeViewDialog">
      <el-form v-show="dialogInfoVisible">
        <el-row >
          <el-form label-width="200px" ref="basic" :model="basic">
            <el-form-item label="录入时间">
              <el-input v-model="basic.fCreateTime" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="是否解绑">
              <el-input v-model="basic.fIsUnbindStr" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="机具编号">
              <el-input v-model="basic.fSn" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="返货SN号">
              <el-input v-model="basic.fReturnSn" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="故障原因">
              <el-input v-model="basic.fQeTrouble" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-input v-model="basic.states" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="寄出快递单号">
              <el-input v-model="basic.fAgentExpressNo" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="收货快递单号">
              <el-input v-model="basic.fLeshuaExpressNo" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="返回配件">
              <el-input v-model="basic.components" type="textarea" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="返修原因">
              <el-input v-model="basic.fReworkAgent" type="textarea" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item ref="" label="照片补充原因" prop="fAgentUrl" >
              <el-form label-width="120px" ref="picForm">
                <div class="photos-content-view">
                  <div>
                    <VueImgInputer
                      v-model="basic.fAgentUrl"
                      theme="material"
                      size="normal"
                      v-loading="picLoadingArr.fAgentUrlShow"
                      :imgSrc="basic.fAgentUrl"
                      class="imgPad img1"
                      :readonly="true"></VueImgInputer>
                  </div>
                </div>
              </el-form>
            </el-form-item>
            <el-form-item label="收件人(寄回)：">
              <el-input v-model="basic.fReceiveName" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系方式：">
              <el-input v-model="basic.fReceiveMobile" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="寄回地址：">
              <el-input v-model="basic.fReceiveAddress" type="textarea" style="width: 50%" disabled></el-input>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row v-show="basic.fState==7 || basic.fState==8 || basic.fState==9 || basic.fState==10 || basic.fState==12 || basic.fState==13 || basic.fState==14">
          <el-form label-width="200px" ref="basic" :model="basic">
            <el-form-item label="付款方银行：">
              <el-input v-model="basic.fBankName" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="付款方户名：">
              <el-input v-model="basic.fBankHolder" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="付款方账号：">
              <el-input v-model="basic.fBankAccount" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="转账日期: ">
              <el-input v-model="basic.fTransferDate" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="转账金额:">
              <el-input v-model="basic.fAgentConfirmAmountStr" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input v-model="basic.fAgentRemark" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="退回原因:" v-show="basic.fFinanceRemark !== null && basic.fFinanceRemark !== '' ">
              <el-input v-model="basic.fFinanceRemark" style="width: 50%" disabled></el-input>
            </el-form-item>
          </el-form>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog title="" :visible.sync="dialogEditVisible" size="small" @close="closeViewDialog">
      <el-form v-show="dialogInfoVisible">
        <el-row >
          <el-form
            label-width="200px"
            ref="basic"
            :model="basic"
            :rules="rule_data">
            <el-form-item label="机具编号" prop="fSn">
              <el-input v-model="basic.fSn" style="width: 50%" placeholder="机具编号" disabled></el-input>
            </el-form-item>
            <el-form-item label="返回配件" prop="FComponents">
              <el-checkbox :indeterminate="isIndeterminate" v-model="componentCheckAll" @change="handleComponentCheckAllChange">全选</el-checkbox>
              <el-checkbox-group v-model="basic.fComponents" @change="handleComponentCheckedChange">
                <el-checkbox label="1">数据线</el-checkbox>
                <el-checkbox label="2">电源适配器</el-checkbox>
                <el-checkbox label="3">包装盒</el-checkbox>
                <el-checkbox label="4">说明书</el-checkbox>
                <el-checkbox label="6">裸机</el-checkbox>
                <el-checkbox label="7">电池</el-checkbox>
                <el-checkbox label="5" style="margin-left: 0px;">
                  其他
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-if="basic.fComponents.includes('5')"
                    v-model="basic.fComponentsRemark">
                  </el-input>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="是否解绑" prop="fIsUnbind">
              <el-radio-group v-model="basic.fIsUnbind">
                <el-radio label="0">不解绑</el-radio>
                <el-radio label="1">解绑</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="返修原因" prop="fReworkAgent">
              <el-input v-model="basic.fReworkAgent" style="width: 50%" type="textarea" placeholder="返修原因" ></el-input>
            </el-form-item>
            <el-form-item ref="" label="照片补充原因" prop="fAgentUrl" >
              <el-form label-width="120px" ref="picForm">
                <div class="photos-content-view">
                  <div>
                    <VueImgInputer
                      v-model="basic.fAgentUrl"
                      theme="material"
                      size="normal"
                      v-loading="picLoadingArr.fAgentUrlShow"
                      :imgSrc="basic.fAgentUrlShow"
                      @onChange="upload('fAgentUrl')"
                      :max-size="picMaxSize"
                      class="imgPad img1"></VueImgInputer>
                  </div>
                </div>
              </el-form>
            </el-form-item>
            <el-form-item label="快递编号" prop="fAgentExpressNo">
              <el-input v-model="basic.fAgentExpressNo" style="width: 50%" placeholder="快递编号" ></el-input>
            </el-form-item>
            <el-form-item label="收件人(寄回)：" prop="fReceiveName">
              <el-input v-model="basic.fReceiveName" style="width: 50%" placeholder="收件人（寄回）：" ></el-input>
            </el-form-item>
            <el-form-item label="联系方式：" prop="fReceiveMobile">
              <el-input v-model="basic.fReceiveMobile" style="width: 50%" placeholder="联系方式：" ></el-input>
            </el-form-item>
            <el-form-item label="寄回地址：" prop="fReceiveAddress">
              <el-input v-model="basic.fReceiveAddress" style="width: 50%" type="textarea" placeholder="寄回地址："></el-input>
            </el-form-item>
          </el-form>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" style="width:100%" v-show="editable === true">
        <el-button @click="dialogEditVisible = false" >取 消
        </el-button>
        <el-button icon="el-icon-edit" type="primary" @click="editSubmit" :loading="addLoading" :disabled="dialogDisabled">修改
        </el-button>
      </span>
    </el-dialog>

    <!-- 申请寄回界面 -->
    <el-dialog title="" :visible.sync="applyBackVisible" size="small" @close="closeViewDialog">
      <el-form>
        <el-row>
          <el-form
            label-width="200px"
            ref="applyForm"
            :model="applyForm"
            :rules="rule_data">
            <h4>寄回信息确认</h4>
            <el-form-item label="收件人" prop="fReceiveName">
              <el-input v-model="applyForm.fReceiveName" style="width: 30%" placeholder="收件人" ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="fReceiveMobile">
              <el-input v-model="applyForm.fReceiveMobile" style="width: 30%" placeholder="联系电话" ></el-input>
            </el-form-item>
            <el-form-item label="寄回地址" prop="fReceiveAddress">
              <el-input v-model="applyForm.fReceiveAddress" style="width: 30%" placeholder="寄回地址" ></el-input>
            </el-form-item>
          </el-form>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" style="width:100%" v-show="applytable === true">
        <el-button @click="applyBackVisible = false">取 消</el-button>
        <el-button icon="el-icon-edit" type="primary" @click="applySubmit" :loading="editLoading" :disabled="dialogDisabled">确认寄回</el-button>
      </span>
    </el-dialog>

    <!-- 查看界面 -->
    <el-dialog title="" :visible.sync="dialogVisible1" size="small" width="35%">
      <div class="codeImgBox">
        <div id="addss" class="transferDialog">
          <h4 style="margin-top: 50px;font-size: 22px">报修总部收货地址</h4>
          <p style="margin-top: 30px">地址：深圳市宝安区西乡街道宝源路华源科技创新园D座421</p>
          <p style="margin-top: 20px">收货人：席新月</p>
          <p style="margin-top: 20px">电话：0755-26923867</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button @click="dialogVisible1 = false" >关  闭</el-button>
      </span>
    </el-dialog>

    <!-- 查看界面 -->
    <el-dialog title="" :visible.sync="dialogVisible2" size="small" width="55%">
      <div class="codeImgBox">
        <div id="price" class="view">
          <h4 style="margin-left: 400px;margin-top: 20px;font-size: 22px">机具维修价格表</h4>
          <div style="width:100%;">
            <div style="float:left; width:15%;height:426px;border:1px solid #000">
              <div style="height:170px;line-height: 200px;border-bottom:1px solid #000;text-align: center;">
                付费维修项目
              </div>
              <div style="height:230px;text-align: center;line-height: 100px">
                易损坏和耗材
                <p style="border-top: 1px solid rgb(0, 0, 0);">50元以上包邮</p>
              </div>
            </div>
            <div style="float:left; width:82%; height:426px; border: 1px solid #000;">
              <table style="width: 100%;margin-left: 10px;">
                <tr>
                  <td class="td2">项目</td>
                  <td class="td2">LP201&LP205</td>
                  <td class="td2">LP203</td>
                  <td class="td2">LP208&LP208B</td>
                  <td class="td2">商务版3.0</td>
                  <td class="td2">商务版4.0</td>
                  <td class="td2">商惠宝</td>
                </tr>
                <tr>
                  <td class="td">人为触发重置</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">更换显示屏</td>
                  <td class="td">180</td>
                  <td class="td">180</td>
                  <td class="td">180</td>
                  <td class="td">180</td>
                  <td class="td">200</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">更换镜片</td>
                  <td class="td">50</td>
                  <td class="td">50</td>
                  <td class="td">50</td>
                  <td class="td">50</td>
                  <td class="td">50</td>
                  <td class="td">50</td>
                </tr>
                <tr>
                  <td class="td">更换SIM卡槽</td>
                  <td class="td">50</td>
                  <td class="td">50</td>
                  <td class="td">50</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">更换纸仓盖</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">卡槽插入异物</td>
                  <td class="td">150</td>
                  <td class="td">150</td>
                  <td class="td">150</td>
                  <td class="td">150</td>
                  <td class="td">150</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">电源适配器</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">100</td>
                </tr>
                <tr>
                  <td class="td">打印胶锟</td>
                  <td class="td">50</td>
                  <td class="td">80</td>
                  <td class="td">50</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">电池</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">100</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">打印纸(24卷/箱)</td>
                  <td class="td">60</td>
                  <td class="td">60</td>
                  <td class="td">60</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">电池盖</td>
                  <td class="td">30</td>
                  <td class="td">40</td>
                  <td class="td">30</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">装机螺丝(一袋/10个)</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">10</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">USB数据线</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">10</td>
                  <td class="td">10</td>
                  <td class="td">X</td>
                </tr>
                <tr>
                  <td class="td">手写笔</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">X</td>
                  <td class="td">10</td>
                  <td class="td">X</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button @click="dialogVisible2 = false" >关  闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// import CountJs from './count.js'
import qs from 'qs'
import VueImgInputer from 'vue-img-inputer'
// import { parseTime } from '@/utils/formatTime'
import { reworkSndetail, applyBackSn, reworkSnMsg } from '@/api/machine'
import { uploadPic } from '@/api/global'
// export default {CountJs};

const componentCheckOptions = ['1', '2', '3', '4', '6', '7', '5']

export default {
  components: {
    VueImgInputer
  },
  data () {
    // const todayStr = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
    // const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
    // const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}')
    return {
      sale_list: [],
      domain: 'https://pos.yeahka.com/',
      salesNum: '',
      search_group_list: [],
      creatTime: '',
      downCtr: true,
      totaldata: {},
      snNum: '',
      dialogVisible: false,
      dialogEditVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogDisabled: false,
      dialogInfoVisible: false,
      applyBackVisible: false,
      applytable: false,
      addLoading: false,
      editLoading: false,
      editable: false,
      componentCheckAll: false,
      isIndeterminate: false,
      picMaxSize: 1024 * 3,
      showPic: {
        fAgentUrl: ''
      },
      picLoadingArr: [{ fAgentUrlShow: false }],
      // 搜索表单信息
      search_sale: {
        startTime: '',
        endTime: '',
        fSn: '',
        fRepairCost: '',
        fState: '',
        pageNo: '',
        pageSize: '10',
        totalCount: ''
      },
      checkLoading: false,
      saleLoading: false,
      basic: {
        fCreateTime: '',
        fIsUnbind: '',
        fIsUnbindStr: '',
        fSn: '',
        fReturnSn: '',
        fQeTrouble: '',
        fState: '',
        states: '',
        fAgentExpressNo: '',
        fLeshuaExpressNo: '',
        fComponents: '',
        components: '',
        fComponentsRemark: '',
        fReworkAgent: '',
        fAgentUrl: '',
        fAgentId: '',
        fReceiveName: '',
        fReceiveMobile: '',
        fReceiveAddress: '',
        fBankName: '',
        fBankHolder: '',
        fBankAccount: '',
        fTransferDate: '',
        fAgentConfirmAmountStr: '',
        fAgentRemark: '',
        fFinanceRemark: '',
        fAgentUrlShow: ''
      },
      applyForm: {
        fId: '',
        fReceiveName: '',
        fReceiveMobile: '',
        fReceiveAddress: '',
        type: ''
      },
      editForm: {
        FId: '',
        FSn: '',
        FComponents: '',
        FComponentsRemark: '',
        FIsUnbind: '',
        FReworkAgent: '',
        FAgentExpressNo: '',
        FReceiveName: '',
        FReceiveMobile: '',
        FReceiveAddress: '',
        FAgentUrl: '',
        FLeshuaExpressNo: '',
        type: '',
        FAgentId: ''
      },
      rule_data: {
        fSn: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入10位机具编号'))
            } else {
              if (!(/^\d{10,10}$/.test(value))) {
                callback(new Error('请输入10位机具编号'))
              } else {
                callback()
              }
            }
          },
          required: true
        }],
        fReceiveName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入真实姓名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,6}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2-6位中文姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        fReceiveMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入11位手机号码或“区号-”格式的座机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value)) && !(/0\d{2,3}-\d{7,8}/.test(value))) {
                callback(new Error('请输入11位手机号码或“区号-”格式的座机号码'))
              } else {
                callback()
              }
            }
          },
          required: true
        }],
        fReceiveAddress: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入寄回地址'))
            }
          },
          required: true
        }],
        fReworkAgent: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入返修原因'))
            }
          },
          required: true
        }],
        fAgentExpressNo: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入快递编号'))
            }
          },
          required: true
        }]
      },
      groupIdDisabledInput: false,
      disabledInput: false,
      // 弹框信息
      addSale: {
        show: false,
        flag: false
      },
      viewSale: {
        show: false,
        flag: false
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      seloading: false,
      accesss: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      props: {
        label: 'name',
        value: 'name',
        children: 'children'
      },
      value7: ''
    }
  },
  methods: {
    /**
       * 返回配件全选点击
       */
    handleComponentCheckAllChange (value) {
      this.basic.fComponents = value ? componentCheckOptions : []
      this.isIndeterminate = false
    },
    /**
       * 返回配件选择点击
       */
    handleComponentCheckedChange (value) {
      const checkedCount = value.length
      this.componentCheckAll = checkedCount === componentCheckOptions.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < componentCheckOptions.length
    },
    dateChange (value) {
      console.log(value)
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_sale.startTime = value[0]
        this.search_sale.endTime = value[1]
      } else {
        this.search_sale.startTime = ''
        this.search_sale.endTime = ''
      }
    },
    closeViewDialog () {
    },
    // 显示查看界面
    showMsg (type) {
      if (type === 2) {
        this.dialogVisible2 = true
      } else {
        this.dialogVisible1 = true
      }
    },
    // 显示查看界面
    handleCheck (index, row, scope) {
      this.dialogVisible = true
      this.dialogInfoVisible = true
      var data = {
        FId: row.fId
      }
      data = qs.stringify(data)
      reworkSndetail(data).then((data) => {
        if (parseInt(data.error_code) === 0) {
          this.basic = data.data
        } else {
          this.$message({
            message: data.error_msg,
            type: 'error'
          })
        }
      })
    },
    // 显示编辑界面
    handleEditSn (index, row, scope) {
      this.dialogEditVisible = true
      this.dialogInfoVisible = true
      this.editable = true
      this.basic.fId = row.fId
      this.basic.fAgentId = row.fAgentId
      console.log(this.basic.fAgentId)
      // this.getRow(row.fMerchantId);
      // this.checkModifyInfo(row.fMerchantId);
      var data = {
        FId: row.fId
      }
      data = qs.stringify(data)
      reworkSndetail(data).then((data) => {
        if (parseInt(data.error_code) === 0) {
          this.basic = data.data
          var FComponents = data.data.fComponents
          this.basic.fComponents = FComponents.split(',')
          this.basic.fAgentUrlShow = data.data.fAgentUrl
          // this.basic.fAgentId = data.data.fAgentId;
          console.log(this.basic.fComponents)
        } else {
          this.$message({
            message: data.error_msg,
            type: 'error'
          })
        }
      })
    },
    // 显示申请寄回界面
    applyBack (index, row, scope) {
      this.applyBackVisible = true
      this.applytable = true
      this.applyForm.fId = row.fId
      // this.getRow(row.fMerchantId);
      // this.checkModifyInfo(row.fMerchantId);
    },
    tableSortChange (val) {
      if (val.prop !== null) {
        if (val.order === 'descending') {
          this.search_sale.orderColumn = val.prop
          this.search_sale.orderType = 1
        } else {
          this.search_sale.orderColumn = val.prop
          this.search_sale.orderType = 0
        }
      }
      this.getList()
    },
    /* 点击搜索按钮事件 */
    onSearch () {
      this.checkLoading = true
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_sale.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    /**
       * 改变页码和当前页时需要拼装的路径方法
       * @param {string} field 参数字段名
       * @param {string} value 参数字段值
       */
    setPath (field, value) {
      var path = this.$route.path
      var query = Object.assign({}, this.$route.query)

      query[field] = value

      this.$router.push({
        path: path,
        query: query
      })
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.snNum
      this.search_sale.pageNo = page
      this.search_sale.pageSize = this.paginations.pageSize
      this.search_sale.Count = totalCount
      this.onSearch()
    },
    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      var totalCount = this.salesNum
      var pageNo = this.paginations.pageNum
      this.search_sale.pageSize = size
      this.search_sale.pageNo = pageNo
      this.search_sale.Count = totalCount
      this.onSearch()
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    // 编辑
    editSubmit () {
      this.editForm.FId = this.basic.fId
      this.editForm.FSn = this.basic.fSn
      this.editForm.FComponentsRemark = this.basic.fComponentsRemark
      this.editForm.FIsUnbind = this.basic.fIsUnbind
      this.editForm.FReworkAgent = this.basic.fReworkAgent
      this.editForm.FAgentExpressNo = this.basic.fAgentExpressNo
      this.editForm.FReceiveName = this.basic.fReceiveName
      this.editForm.FReceiveMobile = this.basic.fReceiveMobile
      this.editForm.FReceiveAddress = this.basic.fReceiveAddress
      this.editForm.FAgentUrl = this.basic.fAgentUrl
      this.editForm.FLeshuaExpressNo = this.basic.fLeshuaExpressNo
      this.editForm.FAgentId = this.basic.fAgentId
      this.editForm.type = '2'

      var that = this
      var FComponents = this.basic.fComponents
      console.log(FComponents.join(','))
      this.editForm.FComponents = FComponents.join(',')

      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.addLoading = true
        that.editLoading = true
        let para = Object.assign({}, that.editForm)
        para = qs.stringify(para)
        applyBackSn(para).then(data => {
          that.addLoading = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getList()
            that.editLoading = false
            this.dialogEditVisible = false
            this.dialogInfoVisible = false
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.editLoading = false
          }
        })
      })
    },
    // 申请寄回提交
    applySubmit () {
      var that = this
      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.addLoading = true
        that.editLoading = true
        this.applyForm.type = '1'
        let para = Object.assign({}, that.applyForm)
        para = qs.stringify(para)
        applyBackSn(para).then(data => {
          that.addLoading = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getList()
            this.applyBackVisible = false
            this.applytable = false
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.editLoading = false
          }
        })
      })
    },
    fStateFormatter (item) {
      var state = item.fState
      if (state === 0) {
        return '未收货'
      }
      if (state === 1 || state === 3) {
        return '已录入'
      }
      if (state === 2) {
        return '收货信息有误'
      }
      if ((state === 4 && item.fRepairCostFlag === 0) || state === 11) {
        return '待付维修款'
      }
      if ((state >= 5 && state <= 8) || (state === 4 && item.fRepairCostFlag === 1) || state === 10 || state === 14 || state === 15) {
        return '维修中'
      }
      if (state === 9) {
        return '已完成'
      }
      if (state === 12) {
        return '待核实费用'
      }
      if (state === 13) {
        return '财务审核失败'
      }
      if (state === 16) {
        return '已申请寄回'
      }
    },
    // 上传图片
    upload (param) {
      var that = this
      // var file = ''
      var picType = param
      var picFile = that.basic[picType]
      var reader = new FileReader()
      that.picLoadingArr[picType] = true
      reader.readAsDataURL(picFile)
      reader.onload = function (e) {
        var file = this.result
        file = file.split('base64,')
        var data = {
          // merchantId : merchantId,
          base64pic: file[1],
          picType: picType
        }
        data = qs.stringify(data)
        uploadPic(data).then(data => {
          that.picLoadingArr[picType] = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.basic.fAgentUrl = data.path // 将绝对路径放到form表单中，存储到数据库中
            // that.editForm["FAgentUrl"] = data.path;
            that.showPic[picType] = data.showPath // 将图片展示路径设置到引用中
            // 上传完成后本地存储
            that.storeToLocal()
          } else {
            that.basic[picType] = ''
            that.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          that.picLoadingArr[picType] = false
          that.basic.fAgentUrl = ''
          that.$message({
            showClose: true,
            message: '图片过大，请压缩后上传！',
            type: 'error'
          })
        })
      }
    },
    /**
      *获取交易统计数据列表
      **/
    getList () {
      this.saleLoading = true
      var data = this.formatSearch(this.search_sale)
      data = qs.stringify(data)
      console.log(data)
      reworkSnMsg(data).then(data => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.saleLoading = false
        } else {
          this.saleLoading = false
          this.paginations.total = data.data.totalCount
          this.snNum = data.data.totalCount
          this.sale_list = data.data.list
          console.log(this.sale_list)
        }
      })
    },
    storeToLocal () {
      const addInfo = {
        basic: JSON.parse(JSON.stringify(this.basic)),
        showPic: this.showPic
      }
      localStorage.setItem('MERCHANT_ADD_INFO', JSON.stringify(addInfo))
    },
    querySearch (queryString, cb) {
      var branchList = []
      var array
      for (var i = 0; i < this.sales_info_list.length; i++) {
        array = { value: this.sales_info_list[i].fAgentAccount, name: this.sales_info_list[i].fName }
        branchList.push(array)
      }
      console.log(branchList)

      var results = queryString ? branchList.filter(this.createFilter(queryString)) : branchList
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) || (restaurant.name.indexOf(queryString) !== -1)
      }
    },
    handleSelect (item) {
      this.search_sale.operatorAccount = item.value
      // this.addForm.unionpay = item.F_branch_no;
    },
    setDefaultDate () {
      const end = new Date()
      // var date = end.getDate()
      // date = date - 1
      // end.setDate(date)
      const start = new Date()
      start.setHours(0)
      start.setMinutes(0)
      start.setSeconds(0)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.creatTime = [start, end]
      this.dateChange(this.creatTime)
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
  }
}

</script>
<style rel="stylesheet/scss" lang="scss">
    .demo-inline-form {
      margin-top: 18px;
    }
    .demo-form-inline {
        display: inline-block;
        float: right;
    }
    .btm-action {
        margin-top: 20px;
        text-align: center;
        .el-select {
          display: none;
          position: relative;
        }
    }
    .pagination {
        display: inline-block;
    }
    .list{
        padding-left: 16px;
    }
    .tab-tag{
      height:0;
      padding: 0;
      line-height: 0;
      background: transparent;
    }
    .dsn{
        display: none;
    }
</style>
